import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface DossieCnpj {
  cnpj: string;
  receita_payload: any;
  receita_atualizado_em: string | null;

  razao_social: string | null;
  nome_fantasia: string | null;
  situacao_cadastral: string | null;
  porte: string | null;
  natureza_juridica: string | null;
  capital_social: number;
  optante_simples: boolean;
  uf: string | null;
  municipio: string | null;
  cep_matriz: string | null;
  cnae_principal: string | null;
  cnae_principal_descricao: string | null;

  assertiva_payload: {
    consulta_id: string;
    protocolo: string | null;
    created_at: string;
    sucesso: boolean;
    resultado: any;
  } | null;

  socios:
    | Array<{
        cpf: string | null;
        nome: string | null;
        qualificacao: string | null;
        participacao: number | null;
        data_entrada: string | null;
        decisor: boolean;
        dados_extra: any;
      }>
    | null;

  total_socios: number;
  total_decisores: number;

  telefones:
    | Array<{
        telefone: string;
        operadora: string | null;
        ultima_consulta: string | null;
        metadata: any;
        historico:
          | Array<{
              operadora_anterior: string | null;
              operadora_nova: string | null;
              observado_em: string;
              data_portabilidade: string | null;
            }>
          | null;
      }>
    | null;

  total_telefones: number;
  total_celulares_nao_claro: number;

  score: number;
}

/**
 * Lê a VIEW vw_dossie_cnpj para um CNPJ específico. Usado para renderizar
 * o DossieCnpjCard após a cascata terminar (ou ao clicar numa linha de
 * Consultas Salvas).
 */
export function useDossieCnpj(cnpj: string | null | undefined) {
  const cnpjClean = (cnpj || '').replace(/\D/g, '');

  return useQuery({
    queryKey: ['dossie-cnpj', cnpjClean],
    enabled: cnpjClean.length === 14,
    staleTime: 60_000, // 1min — VIEW é rápida mas não muda a cada keystroke
    queryFn: async (): Promise<DossieCnpj | null> => {
      console.log('[Ecossistema] useDossieCnpj — buscando VIEW:', cnpjClean);
      const { data, error } = await supabase
        .from('vw_dossie_cnpj' as any)
        .select('*')
        .eq('cnpj', cnpjClean)
        .maybeSingle();
      if (error) {
        // Não derruba a UI — só registra. Isso permite que orquestradorData
        // assuma o controle quando a VIEW falha (não existe, RLS, etc).
        console.warn('[Ecossistema] useDossieCnpj erro (não-fatal):', error);
        return null;
      }
      console.log('[Ecossistema] useDossieCnpj resultado:', data ? 'TEM DOSSIÊ' : 'VAZIO');
      return (data as DossieCnpj) || null;
    },
  });
}
